import React from "react";

const Movies = () => {
  return (
    <div className="info-text">
      <h1>진행 중입니다 😊</h1>
      <p>조금만 기다려 주세요</p>
    </div>
  );
};

export default Movies;
